import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "down2",
  "use": "down2-usage",
  "viewBox": "0 0 90 90",
  "content": "<symbol fill=\"currentColor\" viewBox=\"0 0 90 90\" id=\"down2\">\n  <path fill=\"#000\" d=\"M15 32.895 19.96 28 46 54.04 72.04 28 77 32.895l-31 31-31-31Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol